import React from 'react';
import Row from '../../../../../components/tag/Row';
import OTButton from '../../../../../components/tag/OTButton';
import { FormattedMessage } from 'react-intl';
let { id: module_id } = module;

const FirstContactModalContent = ({ name, save, closeModal }) => {
  return (
    <Row>
      <h4 className={'ot-modal__title'}>
        <FormattedMessage id={`${module_id}.title`} values={{ name }} />
      </h4>
      <p>
        <FormattedMessage id={`${module_id}.content`} />
      </p>
      <Row style={{ textAlign: 'center' }}>
        <OTButton
          message={'OK'}
          color={'darkBlue'}
          onClick={() => {
            save();
            closeModal();
          }}
        />
      </Row>
    </Row>
  );
};

export default FirstContactModalContent;
